import union from 'lodash/union';

import { getCabin, getGuest, getVehicle, getCabinIds, getGuestIds, getVehicleIds, getState } from './selectors';
import { saveRequest } from './actions';

const getAllGuestIds = (...states) => union(...states.map(state => getGuestIds(getState(state))));
const getAllCabinIds = (...states) => union(...states.map(state => getCabinIds(getState(state))));
const getAllVehicleIds = (...states) => union(...states.map(state => getVehicleIds(getState(state))));

const compare = (oldState, newState, getAllFunc, getFunc) =>
  getAllFunc(oldState, newState).filter(id => getFunc(getState(oldState), id) !== getFunc(getState(newState), id));

const getModifiedGuests = (oldState, newState) =>
  compare(oldState, newState, getAllGuestIds, getGuest);
const getModifiedCabins = (oldState, newState) =>
  compare(oldState, newState, getAllCabinIds, getCabin);
const getModifiedVehicles = (oldState, newState) =>
  compare(oldState, newState, getAllVehicleIds, getVehicle);

const watchForGuestChanges = ({ type }) => /CHANGE_(ALL_)?GUESTS?_/.test(type);
const watchForCabinChanges = ({ type }) => /(GUEST.*CABIN|REPLACE_GUEST)/.test(type);
const watchForVehicleChanges = ({ type }) => /CHANGE.*(VEHICLE|TRAILER)/.test(type);

export default store => next => (action) => {
  const stateBefore = store.getState();
  const result = next(action);
  const stateAfter = store.getState();
  if (watchForGuestChanges(action)) {
    getModifiedGuests(stateBefore, stateAfter).forEach(id => store.dispatch(saveRequest(id, 'guests')));
  }
  if (watchForCabinChanges(action)) {
    getModifiedCabins(stateBefore, stateAfter).forEach(id => store.dispatch(saveRequest(id, 'cabins')));
  }
  if (watchForVehicleChanges(action)) {
    getModifiedVehicles(stateBefore, stateAfter).forEach(id => store.dispatch(saveRequest(id, 'vehicles')));
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/store/reservation/middleware.js